import {TRuleConfig} from '../types/TRuleConfig';

export default class Rule {
  type: string;
  config?: TRuleConfig;
  value?: any;

  constructor(type: string, rulesConfig: Map<string, TRuleConfig>, value?: any) {
    this.type = type;
    this.config = rulesConfig.get(this.type);
    this.value = this.config?.defaultValue;
    if (!!value) {
      if (value instanceof Array) {
        if (!!value[0]) {
          this.value[0] = value[0];
        }
        if (!!value[1]) {
          this.value[1] = value[1];
        }
      } else {
        this.value = value;
      }
    }
  }
}
